import { render, staticRenderFns } from "./Bj.vue?vue&type=template&id=1f138e31&"
import script from "./Bj.vue?vue&type=script&lang=js&"
export * from "./Bj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports